import axios from 'axios';

const deployment = window.location.hostname.includes('nsoft.app')
  ? process.env.VUE_APP_GAMES_STATIC_CLOUDFLARE
  : process.env.VUE_APP_GAMES_STATIC_NETLIFY;
const http = axios.create({
  baseURL: deployment,
  timeout: 5000,
});

export default {
  async getTranslations(locale) {
    try {
      const { data } = await http.get(`/i18n/${locale}.json`);
      return data;
    } catch (error) {
      try {
        const { data } = await http.get('/i18n/en.json');
        return data;
      } catch (err) {
        // eslint-disable-next-line
        console.error('Failed to fetch translations:', err);
        throw err;
      }
    }
  },
  async getHelp(productName, locale, companyUuid) {
    // To handle cases like sr-Latn
    const lang = locale.toLowerCase().split('-')[0];
    const game = productName.toLowerCase().replace(/v2$/, '');

    const params = [`${lang}.${companyUuid}`, `${lang}`, 'en'];

    let response;

    const getHelpPage = async (index) => {
      if (index >= params.length) {
        // eslint-disable-next-line
        console.warn("Failed to fetch help");

        if (!window.location.hostname.includes('nsoft.app')) {
          response = await http.get('/help/404.html');
        }

        return response.data;
      }

      try {
        response = await http.get(`/help/${game}.${params[index]}.html`);
        return response.data;
      } catch (error) {
        ({ response } = error);
        return getHelpPage(index + 1);
      }
    };

    return getHelpPage(0);
  },
};
